<template>
    <modal name="agreement_modal"
           :width="changeBrowserSize.width >= 768 ? '600px' : '100%'"
           :height="'auto'"
           :pivotX="0.5"
           :pivotY="0.5"
           :delay="100"
           :reset="true"
           :clickToClose="false"
           @before-open="beforeOpen"
           @before-close="()=>{}">
        <div class="FloatMenu md_overlay md_overlay_0 ">
            <div class="modal modal_0">
                <div class="md_content">
                    <div class="popup_title pb20">
                    </div>
                    <span class="md_close">
                        <img
                            src="/images/union.svg"
                            alt=""
                            @click="disagreeFunctionFire"
                        />
                    </span>
                    <div class="md_agreement">
                        <li class="agree_area">
                            <input type="checkbox" id="agree_check3" v-model="agree_check_arr" value="terms">
                            <label for="agree_check3"><span></span></label>
                            <span class="txt_bold">{{$t('account.necessary')}} </span>
                            <span class="agree_title">{{agreementTitle1}}</span>
                        </li>
                        <vue-friendly-iframe :src="agreementUrl1" :crossorigin="''"
                                             class="container_agreement"/>
                        <li class="agree_area">
                            <input type="checkbox" id="agree_check4" v-model="agree_check_arr" value="personal">
                            <label for="agree_check4"><span></span></label>
                            <span class="txt_bold">{{$t('account.necessary')}} </span>
                            <span class="agree_title">{{agreementTitle2}}</span>
                        </li>
                        <vue-friendly-iframe :src="agreementUrl2" :crossorigin="''"
                                             class="container_agreement"/>

                        <li class="agree_area">
                            <input type="checkbox" id="agree_check_all" :checked="agree_check_all" @click="checkAllFunc()">
                            <label for="agree_check_all"><span></span></label>
                            <span class="txt_bold">{{$t('account.select_All')}} </span>
                            <span class="agree_title">{{$t('account.agree_policy_up')}}</span>
                        </li>
                        <div class="md_button">
                            <a class="btn btn_basics saveBtn no-drag" :class="this.agree_check_arr.length === 2? 'blue pointer' : 'gray'"
                               @click="agreeFunctionFire">
                                {{ $t('agreement.agree') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
    import {_API} from '@/static';

    export default {
      name: 'AgreementModalForKorea',
      components: {},
      props: [''],
      data() {
        return {
          agreementTitle1: '',
          agreementTitle2: '',
          agreementUrl1: '',
          agreementUrl2: '',
          agreeFunction: () => {
            // This is intentional
          },
          agreeFuncParam: [],
          disagreeFunction: () => {
            // This is intentional
          },
          agree_check_arr: [],
          agree_check_all: false,
          browserSize : {
            width: window.innerWidth,
            height: window.innerHeight,
          }
        }
      },
      methods: {
        modalClose: function (event) {
          this.$modal.hide('agreement_modal');
          this.agree_check_arr = [];
          event?.stopPropagation();
          event?.preventDefault();
        },
        beforeOpen(event) {
          this.agreementTitle1 = this.$t('account.the_terms_use');
          this.agreementUrl1 = `${_API}/companyInfo/agreement/termsOfUsage/clinic?tz=${this._TIME_ZONE}`;

          if (this._TIME_ZONE === 'Asia/Seoul') {
            this.agreementTitle2 = this.$t('account.agree_personal_info');
            this.agreementUrl2 = `${_API}/companyInfo/agreement/personalUsage/clinic?tz=${this._TIME_ZONE}`;
          } else {
            this.agreementTitle2 = this.$t('account.privacy_policy');
            this.agreementUrl2 = `${_API}/companyInfo/agreement/privacyPolicy?tz=${this._TIME_ZONE}`;
          }

          this.agree_check_all = event.params.agree_check;
          if (this.agree_check_all) {
            this.agree_check_arr.push('terms', 'personal');
          }
          this.agreeFuncParam = event.params?.agreeFuncParam ?? '';
          this.agreeFunction = event.params?.agreeFunction ?? function () {
            // This is intentional
          };
          this.disagreeFunction = event.params?.disagreeFunction ?? function () {
            // This is intentional
          };
        },
        agreeFunctionFire() {
          if (!this.agree_check_all) {
            return
          }
          if (this.agreeFuncParam !== '') { // 전달받은 함수가 파라메터가 있는 경우
            this.agreeFunction(this.agreeFuncParam);
            this.modalClose();
            return
          }
          this.agreeFunction();
          this.modalClose();
        },
        disagreeFunctionFire() {
          if (this.agree_check_all) {
            this.agreeFunctionFire();
          } else {
            this.disagreeFunction();
            this.modalClose();
          }
        },
        checkAllFunc() {
          if (this.agree_check_arr.length === 2) {
            this.agree_check_arr = [];
          } else {
            this.agree_check_arr = [];
            this.agree_check_arr.push('terms', 'personal');
            this.agree_check_all = true;
          }
        }
      },
      watch: {
        agree_check_arr() {
          if (this.agree_check_arr.length === 2) {
            this.agree_check_all = true;
          } else {
            this.agree_check_all = false;
          }
        },
        changeBrowserSize(value) {
          if ((value.width <= 1024 && this.browserSize.width > 1024) ||
              (value.width > 1024 && this.browserSize.width <= 1024))
            this.modalClose();

          this.browserSize = {
            width: value.width,
            height: value.height,
          }
        }
      },
      computed: {
        changeBrowserSize() {
          return this.$store.getters.getBrowserSize;
        },
      }
    }
</script>

<style lang="scss">
    .v--modal-overlay[data-modal="agreement_modal"] {
        .md_overlay {
            background: none;
        }

        .question {
            margin: 30px auto 30px;
            color: #202020;
            font-size: 20px;
            font-weight: bold;
            line-height: 1.3;
            text-align: center;
        }

        .longQuestion {
            margin: 15px auto 10px;
            color: #202020;
            font-size: 20px;
            font-weight: bold;
            line-height: 1.5;
            text-align: center;
        }

        .yesOrNoBtn {
            display: flex;

            a {
                margin: 40px 10px 0 10px;
            }
        }

        .v--modal {
            box-shadow: none;
        }

        .md_content {
            height: auto;

            & .md_agreement {
                .agree_title {
                    font-size: 15px;
                    color: #202020;
                }

                .container_agreement {
                    height: 150px;
                    border: 1px solid var(--grey20);
                    margin: 10px 15px 30px;
                }

                & .vue-friendly-iframe {
                    & iframe {
                        width: 100%;
                    }
                }
            }

            & .md_button {
                display: flex;

                a {
                    margin: 40px 10px 0 10px;
                }
            }
        }
    }


</style>


